// @flow strict

// $FlowFixMe[nonstrict-import]
import type {ApiOptions, ApiPostOptions} from 'src/utils/redux-api';

import type {
  SendBulkEmailToCandidatePayload,
  AddBulkTagsPayload,
  AddCandidatesToJobPayload,
  TalentPoolCandidate,
} from 'src/types/talent-pools.js';
// $FlowFixMe[nonstrict-import]
import {INITIAL_APPLICANT_LIST_FILTER_DATA} from 'src/components/crm/constant.js';

// $FlowFixMe[untyped-import]
import {fetching, key} from 'src/utils/redux';
// $FlowFixMe[nonstrict-import]
import * as reduxApi from 'src/utils/redux-api.js';
// $FlowFixMe[nonstrict-import]
import {thunkify as flow} from 'src/utils/thunks';

// $FlowFixMe[nonstrict-import]
import type {Dispatch, ThunkAction} from 'src/reducers';


const API_PATH: ApiOptions = {
  apiPath: '/trmapi/api/v1/',
};

const API_POST_PATH: ApiPostOptions = {
  apiPath: '/trmapi/api/v1/',
};

export const TALENT_POOL_CANDIDATE = 'talent-pools/preview-candidate';
export const TALENT_POOL_CANDIDATE_ERROR =
  'talent-pools/preview-candidate-error';
export const TRM_APPLICANTS = 'talent-pools/trm-applicants';
export const TRM_APPLICANTS_ERROR = 'talent-pools/trm-applicants-error';

type TalentPoolPreviewCandidateAction = {
  type: typeof TALENT_POOL_CANDIDATE,
  payload: TalentPoolCandidate,
};

type TalentPoolPreviewCandidateErrorAction = {
  type: typeof TALENT_POOL_CANDIDATE_ERROR,
  payload: Error,
};

type TRMApplicantsAction = {
  type: typeof TRM_APPLICANTS,
  payload: TalentPoolCandidate,
};

type TRMApplicantsErrorAction = {
  type: typeof TRM_APPLICANTS_ERROR,
  payload: Error,
};

export type TalentPoolCandidateActions =
  | TalentPoolPreviewCandidateAction
  | TalentPoolPreviewCandidateErrorAction
  | TRMApplicantsAction
  | TRMApplicantsErrorAction;

export const getPreviewCandidate: (talentPoolId: number) => ThunkAction<void> =
  flow(
    key(
      (talentPoolId: number) =>
        `talent-pool-folders/${talentPoolId}/candidates/preview`,
    ),
    fetching(),
  )((talentPoolId: number) => (dispatch: Dispatch) => {
    return dispatch(
      reduxApi.get<TalentPoolCandidate>(
        `talent-pool-folders/${talentPoolId}/candidates/preview`,
        {},
        API_PATH,
      ),
    )
      .then((response: TalentPoolCandidate) => {
        dispatch({
          type: TALENT_POOL_CANDIDATE,
          payload: response,
        });
      })
      .catch((error: Error) => {
        dispatch({
          type: TALENT_POOL_CANDIDATE_ERROR,
          payload: error,
        });
      });
  });

export const getTalentPoolCandidates: (
  talentPoolId: number,
  query: {
    page: number,
    page_size?: number,
    q?: string,
  },
) => ThunkAction<void> = flow(
  key(
    (talentPoolId: number) => `talent-pool-folders/${talentPoolId}/candidates`,
  ),
  fetching(),
)((talentPoolId, query) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.get<TalentPoolCandidate>(
      `talent-pool-folders/${talentPoolId}/candidates`,
      {
        ...query,
      },
      API_PATH,
    ),
  )
    .then((response: TalentPoolCandidate) => {
      dispatch({
        type: TALENT_POOL_CANDIDATE,
        payload: response,
      });
    })
    .catch((error: Error) => {
      dispatch({
        type: TALENT_POOL_CANDIDATE_ERROR,
        payload: error,
      });
    });
});

export const sendBulkEmailToCandidate: (
  payload: SendBulkEmailToCandidatePayload,
) => ThunkAction<void> = flow(
  key(() => `talent-pool-folders/bulk/send-mail`),
  fetching(),
)((payload) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `talent-pool-folders/bulk/send-mail`,
      payload,
      {},
      API_POST_PATH,
    ),
  )
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
});

export const addBulkTags: (payload: AddBulkTagsPayload) => ThunkAction<void> =
  flow(
    key(() => `talent-pool-folders/bulk/add-tags`),
    fetching(),
  )((payload) => (dispatch: Dispatch) => {
    return dispatch(
      reduxApi.post(
        `talent-pool-folders/bulk/add-tags`,
        payload,
        {},
        API_POST_PATH,
      ),
    )
      .then((response) => response)
      .catch((err) => {
        throw err;
      });
  });

export const addCandidatesToJob: (
  payload: AddCandidatesToJobPayload,
) => ThunkAction<void> = flow(
  key(() => `talent-pool-folders/bulk/add-to-job`),
  fetching(),
)((payload) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `talent-pool-folders/bulk/add-to-job`,
      payload,
      {},
      API_POST_PATH,
    ),
  )
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
});

export const removeCandidatesFromFolders: ({
  candidate_ids: number[],
  talent_pool_folder_ids: number[],
  all: boolean,
}) => ThunkAction<void> = flow(
  key(() => `talent-pool-folders/bulk/remove-candidates-from-folders`),
  fetching(),
)((payload) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `talent-pool-folders/bulk/remove-candidates-from-folders`,
      payload,
      {},
      API_POST_PATH,
    ),
  )
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
});

export const addCandidatesToFolders: ({
  candidate_ids: number[],
  talent_pool_folder_ids: number[],
  all: boolean,
}) => ThunkAction<void> = flow(
  key(() => `talent-pool-folders/bulk/add-candidates-to-folders`),
  fetching(),
)((payload) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `talent-pool-folders/bulk/add-candidates-to-folders`,
      payload,
      {},
      API_POST_PATH,
    ),
  )
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
});

export const moveCandidatesToFolders: ({
  candidate_ids: number[],
  source_talent_pool_folder_id: number,
  destination_talent_pool_folder_ids: number[],
  all: boolean,
}) => ThunkAction<void> = flow(
  key(() => `talent-pool-folders/bulk/move-candidates-to-folders`),
  fetching(),
)((payload) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `talent-pool-folders/bulk/move-candidates-to-folders`,
      payload,
      {},
      API_POST_PATH,
    ),
  )
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
});

export const copyCandidatesToFolders: ({
  candidate_ids: number[],
  source_talent_pool_folder_id: number,
  destination_talent_pool_folder_ids: number[],
  all: boolean,
}) => ThunkAction<void> = flow(
  key(() => `talent-pool-folders/bulk/copy-candidates-to-folders`),
  fetching(),
)((payload) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `talent-pool-folders/bulk/copy-candidates-to-folders`,
      payload,
      {},
      API_POST_PATH,
    ),
  )
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
});

export const getTRMApplicants: (
  searchText: string,
  query: {
    page: number,
    pageSize?: number,
    type?: string,
    folderId?: number,
    searchId?: number,
    sortBy?: string,
  },
) => ThunkAction<void> = flow(
  key(() => `talent-pool-folders/bulk/candidates`),
  fetching(),
)((searchText, query) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post<TalentPoolCandidate>(
      `talent-pool-folders/bulk/candidates`,
      {
        ...INITIAL_APPLICANT_LIST_FILTER_DATA.filter,
        q: [searchText ?? ''],
      },
      {
        ...query,
      },
      API_POST_PATH,
    ),
  )
    .then((response: TalentPoolCandidate) => {
      dispatch({
        type: TRM_APPLICANTS,
        payload: response,
      });
    })
    .catch((error: Error) => {
      dispatch({
        type: TRM_APPLICANTS_ERROR,
        payload: error,
      });
    });
});

export const getPhoneNumbersForCandidates: ({
  all: boolean,
  candidate_ids: number[],
  talent_pool_folder_id: number,
}) => ThunkAction<void> = flow(
  key(() => `talent-pool-folders/bulk/phone-number`),
  fetching(),
)((payload) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `talent-pool-folders/bulk/phone-number`,
      payload,
      {},
      API_POST_PATH,
    ),
  );
});

export const addOrRemoveCandidatesFromFolders: ({
  candidate_id: number,
  talent_pool_folder_ids: number[],
}) => ThunkAction<void> = flow(
  key((candidateId) => `talent-pool-folders/candidates/${candidateId}/folders`),
  fetching(),
)(({candidate_id, talent_pool_folder_ids}) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `talent-pool-folders/candidates/${candidate_id}/folders`,
      {talent_pool_folder_ids},
      {},
      API_POST_PATH,
    ),
  );
});

export const addOrRemoveCandidatesToFoldersFromJob: ({
  talent_pool_folder_ids: number[],
  job_id: number,
  all: boolean,
  candidate_ids: number[],
  matching_parameter: {},
}) => ThunkAction<void> = flow(
  key(() => `talent-pool-folders/bulk/add-candidates-to-folders-from-job`),
  fetching(),
)((payload) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `talent-pool-folders/bulk/add-candidates-to-folders-from-job`,
      payload,
      {},
      API_POST_PATH,
    ),
  );
});

export const updateCandidateViewColumns: (
  folderId: number,
  payload: {columns: {[string]: boolean}},
) => ThunkAction<void> = flow(
  key((folderId) => `talent-pool-folders/${folderId}/candidate-view-columns`),
  fetching(),
)((folderId, payload) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `talent-pool-folders/${folderId}/candidate-view-columns`,
      payload,
      {},
      API_POST_PATH,
    ),
  ).then((response) => response?.columns);
});
